export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5496.7f94d3ab.jpg";